export enum ValidBulkUploadFields {
  digitalPropertyName = 'Digital asset name',
  key = 'Digital asset key',
  type = 'Type',
  url = 'URL',
  bundleId = 'Bundle ID',
  monitoring = 'Monitoring?',
  recurrence = 'Recurrence',
  startPage = 'Start page',
  maxNumberOfPages = 'Maximum Number of pages',
  crawlDepth = 'Crawl Depth',
  wcagLevel = 'WCAG Conformance level and version',
  viewport = 'Viewport size',
  workspaceName = 'Workspace Name',
  description = 'Description',
}

export const WORKBOOK_HEADERS_ROW_INDEX: number = 1;

export const DP_QUICK_SETUP_SHEET_NAME: string = 'Sheet1';
export const DP_WITH_MONITORING_SETTINGS_SHEET_NAME: string = 'Websites and Apps';
export const WORKSPACES_SHEET_NAME: string = 'Workspaces';

export const ValidDPQuickSetupFields: string[] = [
  'Digital asset name',
  'Digital asset key',
  'Type',
  'URL',
  'Bundle ID',
  'Monitoring?',
];
export const ValidWorkspaceFields: string[] = ['Workspace Name', 'Description'];
export const ValidDPBulkWorkspaceFields: string[] = [
  'Workspace Name',
  'Digital asset name',
  'Digital asset key',
  'Type',
  'URL',
  'Bundle ID',
  'Monitoring?',
  'Recurrence',
  'Start page',
  'Maximum Number of pages',
  'Crawl Depth',
  'WCAG Conformance level and version',
  'Viewport size',
];

export const ValidDPAdvancedFields: string[] = [
  'Digital asset name',
  'Digital asset key',
  'Type',
  'URL',
  'Bundle ID',
  'Monitoring?',
  'Recurrence',
  'Start page',
  'Maximum Number of pages',
  'Crawl Depth',
  'WCAG Conformance level and version',
  'Viewport size',
];

export enum BulkUploadErrors {
  missingOrUnexpectedColumn = 'error_column_missing_or_unexpected',
  missingMultipleColumns = 'error_multiple_columns_missing',
  missingDigitalPropertyName = 'error_missing_digital_property_name',
  takenDigitalPropertyName = 'error_digital_property_name_taken',
  missingDigitalPropertyKey = 'error_missing_digital_property_key',
  takenDigitalPropertyKey = 'error_digital_property_key_taken',
  invalidLengthDigitalPropertyKey = 'error_digital_property_key_length',
  missingDigitalPropertyType = 'error_digital_property_type_missing',
  invalidDigitalPropertyType = 'error_digital_property_type_invalid',
  missingDigitalPropertyURL = 'error_digital_property_url_missing',
  invalidDigitalPropertyMonitoring = 'error_digital_property_monitoring_invalid',
  invalidDigitalPropertyURL = 'error_digital_property_url_invalid',
  duplicateDigitalPropertyName = 'error_digital_property_duplicate_name',
  duplicateDigitalPropertyKey = 'error_digital_property_duplicate_key',
  duplicateDigitalPropertyURL = 'error_digital_property_duplicate_url',
  invalidRecurrence = 'error_recurrence_invalid',
  invalidStartPage = 'error_start_page_invalid',
  invalidMaxNumberOfPages = 'error_max_number_of_pages_invalid',
  invalidCrawlDepth = 'error_crawl_depth_invalid',
  invalidWcagLevelAndVersion = 'error_wcag_level_and_version',
  invalidViewport = 'error_viewport_invalid',
  unexpectedMonitoringFieldForNonWebsite = 'error_non_website_unexpected_monitoring_field',
  unexpectedMonitoringFieldForMonitoringDisabled = 'error_monitoring_disabled_unexpected_monitoring_field',
  invalidWorkbook = 'error_invalid_workbook',
  duplicateWorkspaceName = 'error_workspace_duplicate_name',
  overMaxWorkspaceWorksheetRows = 'error_over_max_workspaces_worksheet_rows',
  overMaxDpWorksheetRows51 = 'error_over_max_digital_properties_worksheet_rows_51',
  overMaxDpWorksheetRows1001 = 'error_over_max_digital_properties_worksheet_rows_1001',
  missingWorkspaceName = 'error_missing_workspace_name',
  missingWorkspaceDescription = 'error_missing_workspace_description',
  takenWorkspaceName = 'error_workspace_name_taken',
  workspaceWithoutAssociatedDp = 'error_workspace_without_digital_property',
  dpWithoutAssociatedWorkspace = 'error_digital_property_without_workspace',
  workspaceDoesNotExist = 'error_workspace_does_not_exist',
  cannotCreateDpForExistingWorkspace = 'error_cannot_create_dp_existing_workspace',
  digitalPropertyLimitExceeded = 'error_exceeds_tenant_limit_websites_apps',
  dpNameTooLong = 'error_dp_name_too_long',
  workspaceNameTooLong = 'error_workspace_name_too_long',
  workspaceDescriptionTooLong = 'error_workspace_description_too_long',
  invalidDigitalPropertyKey = 'error_invalid_digital_property_key',
  invalidBundleId = 'error_bundle_id_invalid',
  missingBundleId = 'error_bundle_id_missing',
}

export const bulkUpload: string = 'bulkUpload';
